import styled from 'styled-components'
import { newColors } from '@sabavision/dio'

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  overflow-x: hidden;
`
export { Wrapper }

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`
export { Container }

const Scroll = styled.div`
  width: 100%;
  height: calc(100vh - 45px);
  margin: 0;
  padding: 0;
  align-self: center;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 2.5px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${newColors.gray};
    border-radius: 2.5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${newColors.gray};
  }
`
export { Scroll }

const Page = styled.div`
  width: 100%;
  max-width: 1365px;
  min-height: calc(100vh - 65px - 14px);
  margin-block: 7px;
  margin-inline: auto;
`
export { Page }
